define('app-console/lib/group',['require','exports','module','./console'],function(require,exports,module){
    var konsole=require('./console');

    var	_noop=function(){},
    	group = {
		start : konsole.trueConsole && function(ns){
			if(ns!=null){
				if(group.current!==ns){
					group.end();
					group.current=ns;				
					konsole.group(ns);
				}
			}
		} || _noop,
		end   : konsole.trueConsole && function(ns){
				if(group.current!==""){
					group.current="";
					konsole.groupEnd(ns);
				}
		} || _noop,

		current : ""
	};

	return group;

})
;
